import { LANGUAGES } from 'constant/language';
import translations from './translation.json';

let selectedLanguage = window.localStorage.getItem('selectedLanguage') || LANGUAGES.find((e) => e.default).code;

/**
 * Set the selected language
 * @param {String} langCode in the form of standard language code like "de" for German language
 */
export const setLanguage = (langCode = '') => {
  const code = langCode === 'es' ? 'en' : langCode;
  const language = LANGUAGES.find((e) => e.code === code);
  if (language) {
    selectedLanguage = language.code;
    window.localStorage.setItem('selectedLanguage', langCode);
  }
};

export const getCurrentLanguage = () => selectedLanguage;

export const _tWithDeps = (localTranslations = {}) => (key = '') => {
  const [firstKey, ...restKeys] = key.match(/\s/) ? [key] : key.split('.');
  if (restKeys.length > 0) {
    return _tWithDeps(localTranslations[firstKey])(restKeys.join('.'));
  }
  if (localTranslations[key] && localTranslations[key][selectedLanguage]) {
    return localTranslations[key][selectedLanguage];
  }
  return key;
};

/**
 * Translate the phrase to the selected language
 * @param {String} key the phrase which need to be translated
 * @returns {String} translated phrase
 */
export const _t = _tWithDeps(translations);

export const _tfWithDeps = (localTranslations) => {
  const tFunction = _tWithDeps(localTranslations);
  return function _tf(key, ...rest) {
    let translation = tFunction(key);
    if (typeof rest !== 'undefined' && rest.length > 0) {
      const type = typeof rest[0];
      const args = (['string', 'number'].includes(type))
        ? Array.prototype.slice.call(rest)
        : rest[0];

      for (const r in args) {
        if (Array.isArray(args) || Object.prototype.hasOwnProperty.call(args, r)) {
          translation = translation.replace(new RegExp(`\\{${r}\\}`, 'gi'), args[r]);
        }
      }
    }

    return translation;
  };
};

export const _tf = _tfWithDeps(translations);
